<!--
 * @Description: 报名弹框
 * @Author: black-k
 * @Date: 2025-09-11 09:23:41
 * @LastEditors: black-k
 * @LastEditTime: 2025-09-11 16:07:46
-->
<template>
    <div class="basic-dialog task-dialog signup-dialog">
        <el-dialog
            :title="title"
            :visible="visible"
            @update:visible="handleUpdateVisible"
            width="720px"
            :close-on-click-modal="false"
            :destroy-on-close="true"
        >
            <el-scrollbar class="dialog-scrollbar">
                <slot name="tip"></slot>

                <ActionForm
                    ref="actionFormRef"
                    :desc="{
                        label: '报名说明',
                        placeholder: '请填写你匹配该任务的能力、优势等，也可提交附件证明',
                    }"
                    :other-rules="rules"
                >
                    <template slot="custom" slot-scope="scope">
                        <el-form-item label="报价:金币" prop="price">
                            <el-input-number
                                v-model="scope.form.price"
                                :min="1"
                                :max="999999999"
                                placeholder="请输入"
                                :precision="0"
                                :controls="false"
                            ></el-input-number>
                        </el-form-item>
                    </template>
                </ActionForm>
            </el-scrollbar>

            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="handleUpdateVisible(false)">取 消</el-button>
                <el-button size="mini" type="primary" @click="handleConfirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import ActionForm from "./ActionForm.vue";
import { request } from "../../util";
import taskApi from "@/apis/task";
import { v4 } from "uuid";
import { isEmpty } from "@/utils/common";

export default {
    data() {
        return {
            rules: {
                price: [{ required: true, message: "请输入报价", trigger: "blur" }],
            },

            request: request(),
        };
    },

    props: {
        visible: {
            type: Boolean,
            required: true,
        },

        title: {
            type: String,
            default: "报名信息",
        },

        taskId: {
            type: Number,
        },
    },

    components: {
        ActionForm,
    },

    watch: {
        visible(val) {
            if (val) {
                this.getSignDetail();
            }
        },
    },

    methods: {
        reset() {
            this.$refs.actionFormRef?.reset?.();
        },

        handleUpdateVisible(val) {
            this.$emit("update:visible", val);

            if (!val) {
                this.reset();
            }
        },

        handleConfirm() {
            this.$refs.actionFormRef?.validate((valid, data) => {
                if (valid) {
                    this.$emit("confirm", {
                        is_privacy: 1, // 报名-统一设置隐私
                        price: data.price,
                        description: data.description,
                        urls: data.urls.map((item) => ({ name: item.name, url: item.url })),
                        files: [...data.files],
                    });
                }
            });
        },

        getSignDetail() {
            if (!this.taskId) return;

            const params = { task_id: this.taskId };

            this.request.axiosGetBy(taskApi.taskApplyInfo, params, (res) => {
                if (res.code === 200) {
                    if (isEmpty(res.data)) return;

                    const data = {
                        price: res.data?.price,
                        description: res.data?.description,
                        urls: res.data?.urls?.map((item) => ({ ...item, key: v4().replaceAll("-", "") })),
                        files: res.data?.files,
                    };

                    this.$refs.actionFormRef?.initData?.(data);
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.signup-dialog {
    ::v-deep .el-input-number {
        width: 100%;

        .el-input__inner {
            text-align: left;
        }
    }
}
</style>
